import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

const FAQS = [
  {
    q: "How does the up-to-50% first-year discount work?",
    a: "We base your first-term discount on the invoice from your current insurance provider. The stronger your loss history, the deeper the discount — up to 50% off your first premium, confirmed within one business day of receiving your invoice.",
  },
  {
    q: "How fast are FMCSA and state filings submitted?",
    a: "Standard federal and state filings are submitted within 15 minutes of binding coverage during business hours, and within one business day otherwise. You get confirmation and your certificates the same day in most cases.",
  },
  {
    q: "Which coverages do I need to operate legally?",
    a: "At minimum, federal primary liability at $750,000 for-hire carriers, plus any state-specific requirements. Most operations add motor truck cargo and physical damage. We build the package around your authority and freight mix.",
  },
  {
    q: "Do you insure fleets in my state?",
    a: "Yes — Fleetguard writes commercial truck policies in all 50 states, with local filing expertise for every jurisdiction your trucks cross.",
  },
  {
    q: "What happens when I file a claim?",
    a: "Our claims line is staffed 24/7 by people, not menus. Report the loss any time; a dedicated adjuster is assigned immediately and keeps you updated through settlement.",
  },
  {
    q: "What do I need to become a client?",
    a: "Download and sign the client agreement, then return it with your DOT/MC authority, driver list, and the invoice from your current insurer — that invoice is what unlocks your first-term discount.",
  },
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="bg-white py-16 sm:py-24">
    <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-12 lg:gap-20 lg:px-8">
      <div className="lg:col-span-5">
        <Reveal>
          <p className="eyebrow">FAQ</p>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-brand-navy sm:text-4xl lg:text-[2.75rem] lg:leading-[1.1]">
            Straight answers, before you even ask.
          </h2>
          <p className="mt-5 text-base leading-relaxed text-slate-600">
            Can't find your question? Call us — a licensed agent picks up, not a phone tree.
          </p>
        </Reveal>
      </div>
      <div className="lg:col-span-7">
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-slate-200">
                <AccordionTrigger
                  className="py-5 text-left font-display text-lg font-semibold text-brand-navy hover:text-brand-blue hover:no-underline"
                  data-testid={`faq-trigger-${i}`}
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-[15px] leading-relaxed text-slate-600" data-testid={`faq-content-${i}`}>
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
